import React, { useContext, useState } from "react";
import { CommandBarButton, ButtonProps } from "sprint-common-web";

import { MergeAncillariesRequest } from "../../api/MergeAncillariesRequest";
import { useAssetsManageAncillaryApi } from "../../api/useAssetsManageAncillaryApi";
import { ManageAncillaryContext } from "../../context/ManageAncillaryContext";
import { AncillaryItem } from "../AncillaryItem";
import { MergeAncillariesConfirmationModal } from "./MergeAncillariesConfirmationModal";

export const MergeAncillariesButton: React.FC<ButtonProps> = (props: ButtonProps) => {
    const { mergeAncillaries } = useAssetsManageAncillaryApi();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { ancillariesToMerge, ancillaryContentType, markAncillaryAsMerged, clearAncillariesToMerge } = useContext(
        ManageAncillaryContext
    );

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const hasDataToMerge = ancillariesToMerge.length === 2;

    const [target, orphan] = ancillariesToMerge;

    const handleMergeButtonClick = async (): Promise<void> => {
        setIsLoading(true);
        await mergeAncillaries(createRequest(target, orphan));

        markAncillaryAsMerged(orphan.id);
        clearAncillariesToMerge();

        closeModal();
        setIsLoading(false);
    };

    const buttonDisabled = props.disabled || !hasDataToMerge;

    return (
        <>
            <CommandBarButton onClick={openModal} text="Merge" icon="Merge" disabled={buttonDisabled} />
            <MergeAncillariesConfirmationModal
                ancillaryContentType={ancillaryContentType}
                targetAncillary={target}
                orphanedAncillary={orphan}
                isOpen={isModalOpen}
                isConfirmationDisabled={isLoading}
                onConfirm={handleMergeButtonClick}
                onDismiss={closeModal}
            />
        </>
    );
};

const createRequest = (target: AncillaryItem, orphan: AncillaryItem): MergeAncillariesRequest => {
    return {
        targetAncillaryId: target.id,
        orphanedAncillaryId: orphan.id
    };
};
